<div *ngIf="!(isDetail && [companies.SeaIm].includes(company))" style="position: relative; min-height: 100px;">
  <ngx-spinner [fullScreen]="false" bdColor="rgba(255,255,255,0.8)" color="#000000" name="schedule" size="default"
               type="line-spin-clockwise-fade"></ngx-spinner>

  <div class="d-flex align-items-center">
    <div class="l2-title">Schedule</div>
    <div (click)="resetScheduleDate()"
         *ngIf="isTicketEditable && isDetail && ([companies.Seca].includes(company) && this.basic.processType === 'ZR01')"
         class="d-flex btn btn-service-center-search">
      <i class="fa-regular fa-magnifying-glass"></i>
      <span class="ms-1">
        {{ [companies.Seca].includes(company) ? 'Find Service Centre' : 'Find Service Center' }}
    </span>
    </div>
  </div>

  <ng-container *ngIf="isDetail && scheduleDate; else isEdit">
    <form (keydown.enter)="$event.preventDefault()" [formGroup]="scheduleForm">
      <div class="item-row mb-8px">
        <div class="item-label">Schedule Date</div>
        <div class="item-value">
          <div [ngClass]="{'disable-admin-viewer': isAdminViewerRole}" class="input-group input-calendar-condition">
            <input
              #dp="bsDatepicker"
              [bsConfig]="bsConfig"
              [minDate]="beforeDate"
              [readOnly]="true"
              bsDatepicker
              class="form-control input-search-condition py-2"
              formControlName="scheduleDate"
              placement="top"
              type="text"/>
            <span class="input-group-text bg-transparent">
              <img (click)="isDealer ? false : dp.toggle()"
                   [attr.aria-expanded]="dp.isOpen"
                   class="duration-icon"
                   src="assets/img/ico-duration.svg"/>
            </span>
          </div>
        </div>
        <div *ngIf="![companies.Seca].includes(company)" class="item-label">Schedule Time</div>
        <div *ngIf="![companies.Seca].includes(company)" class="item-value">
          <timepicker [disabled]="isAdminViewerRole"
                      [showSpinners]="false"
                      formControlName="scheduleTime">
          </timepicker>
        </div>
      </div>
    </form>
  </ng-container>
  <ng-template #isEdit>
    <ng-container *ngIf="serviceCenters && serviceCenters.length; else NoServiceCenterTemp">
      <div *ngIf="[companies.Sea].includes(company) && preferredServiceCenters.length > 0" class="d-flex flex-column">
        <div class="btn-schedule-container">
          <button (click)="onPageEvent('Prev')" [disabled]="pagingDate?.firstElement === pagingDate?.prevDate"
                  class="btn-schedule-move"
                  role="button">
            <font-awesome [cssClass]="'font-size-14'" [icon]="'fa-regular fa-chevron-left'"></font-awesome>
          </button>
          <button (click)="onPageEvent('Next')" [disabled]="pagingDate?.lastElement === pagingDate?.prevDate"
                  class="btn-schedule-move ml-12px"
                  role="button">
            <font-awesome [cssClass]="'font-size-14'" [icon]="'fa-regular fa-chevron-right'"></font-awesome>
          </button>
        </div>
      </div>

      <div class="table-wrapper py-0">
        <table class="table align-middle table-nowrap table-check">
          <thead>
          <tr>
            <th class="align-middle item-label" colspan="3">
              <div class="d-flex row">
                <div class="col-md-6">{{ [companies.Seca].includes(company) ? 'Service Centre' : 'Service Center' }}
                </div>
                <div *ngIf="[companies.Seca, companies.SeaIm].includes(company)" class="col-md-6 text-right">Please
                  select service center
                </div>
              </div>
            </th>
            <ng-container *ngIf="[companies.Sea].includes(company)">
              <th *ngFor="let schedule of serviceCentersSchedule[0]" class="text-center text-nowrap">
                <div class="text-day-week">{{ moment.parseZone(schedule.date).format('ddd') }}</div>
                <div class="text-day">{{ moment.parseZone(schedule.date).format('MM/DD') }}<br/></div>
              </th>
            </ng-container>
          </tr>
          </thead>

          <ng-container *ngIf="[companies.Sea].includes(company); else secaAndMxDatePick">
            <tbody>
            <tr *ngIf="preferredServiceCenters.length < 1 && !userAgreement">
              <th class="text-center text-preferred-label-description" colspan="10">
                Recommended Service Centers are not available for now. Please click the 'show more' to get more
                information.
              </th>
            </tr>
            <!-- preferred service centers -->
            <tr *ngFor="let sc of preferredServiceCenters; index as i;" [attr.data-asc-no]="sc.ascNo">
              <td class="align-middle">
                <div class="mb-8px">
                  <span class="text-asc-no">{{ sc.ascNo }}</span>
                  <span [class.text-preferred-label-color-blue]="true"
                        [class.text-preferred-label]="true"
                  >{{ sc.preferredLabel }}</span>
                  <ng-container *ngIf="sc.redo">
                    <dp-badge [color]="'red'" [text]="'REDO'" class="ml-1"></dp-badge>
                  </ng-container>
                </div>
                <div class="text-service-center">
                  <span class="font-weight-bold">{{ sc.name }}</span>
                  <span *ngIf="[companies.SeaIm].includes(company)" class="pl-8px font-size-11">
                  {{
                      sc.address?.address1.concat(', ')
                        .concat(sc.address?.city).concat(', ')
                        .concat(sc.address?.state).concat(', ')
                        .concat(sc.address?.zipcode)
                    }}</span>
                </div>
              </td>

              <!-- Center Type & Star -->
              <td class="align-middle text-center">
                <div role="button">
                  <div class="text-service-center">{{ sc.centerType }}</div>
                  <div *ngIf="sc.star" class="text-nowrap" style="font-size: 0.6rem;">
                    <app-star-rating [forDisplay]="true" [score]="sc.star"></app-star-rating>
                  </div>
                </div>
              </td>

              <!-- Slot name & Pick Button -->
              <td class="text-center">
                <!-- schedules null is pick -->
                <ng-container *ngIf="sc.schedules | capacity; else isPick">
                  <ng-container *ngFor="let schedule of sc.schedules; first as isFirst">
                    <ng-container *ngIf="isFirst">
                      <div *ngFor="let key of schedule.capacity | keys" class="text-service-key">
                        {{ key | uppercase }}
                      </div>
                    </ng-container>
                  </ng-container>
                </ng-container>
                <ng-template #isPick>
                  <button (click)="onSelectedPick(sc, null)"
                          [ngClass]="{'active-schedule': sc.ascNo === this.serviceCenter?.ascNo && !this.serviceCenter?.schedule}"
                          class="btn btn-sm btn-outline-schedule pt-0 pb-0" role="button">
                    <i class="fal fa-check"></i>
                  </button>
                </ng-template>
              </td>

              <!-- Daily Slot Buttons -->
              <ng-container *ngIf="[companies.Sea].includes(company)">
                <td *ngFor="let schedule of serviceCentersSchedule[i]" class="text-center">
                  <ng-container *ngIf="sc.schedules | capacity; else isSelectedPick">
                    <ng-container *ngFor="let key of schedule.capacity | keys">
                      <ng-container *ngIf="schedule.capacity[key]; else capacity">
                        <button (click)="onSelected(sc, schedule, key)"
                                [disabled]="schedule.capacity[key] < 0"
                                class="btn btn-sm btn-outline-schedule pt-0 pb-0">
                          <ng-container *ngIf="schedule.capacity[key] < 0; else capacityTmp">
                            <i class="fal fa-check"></i>
                          </ng-container>
                          <ng-template #capacityTmp>
                            <div [ngClass]="{'active-schedule': schedule.date === this.serviceCenter?.schedule?.date &&
                                          schedule.capacity[key] === this.serviceCenter?.schedule?.capacity[this.serviceCenter?.schedule?.key]}"
                                 class="default-slot">
                              {{ schedule.capacity[key] }}
                            </div>
                          </ng-template>
                        </button>
                        <br/>
                      </ng-container>
                      <ng-template #capacity>
                        <div class="default-slot">&nbsp;</div>
                      </ng-template>
                    </ng-container>
                  </ng-container>
                  <ng-template #isSelectedPick>
                    <button (click)="onSelectedPick(sc, schedule)"
                            *ngIf="!schedule.blocked"
                            [ngClass]="{'active-schedule': schedule === this.serviceCenter?.schedule}"
                            class="btn btn-sm btn-outline-schedule pt-0 pb-0">
                      <i class="fal fa-check"></i>00
                    </button>
                  </ng-template>
                </td>
              </ng-container>
            </tr>

            <!-- other service centers -->
            <ng-container *ngIf="!userAgreement && otherServiceCenters.length > 0">
              <tr>
                <td class="text-center" colspan="10">
                  <div (click)="openPopUp()" class="btn">
                    show more
                    <div>
                      <i class="fa-duotone fa-arrow-down"
                         style="--fa-primary-color: #000000; --fa-secondary-color: #ffffff;"></i>
                    </div>
                  </div>
                </td>
              </tr>
            </ng-container>

            <ng-container *ngIf="userAgreement">
              <tr *ngFor="let sc of otherServiceCenters; index as i;" [attr.data-asc-no]="sc.ascNo">
                <td class="align-middle">
                  <div class="mb-8px">
                    <span class="text-asc-no">{{ sc.ascNo }}</span>
                    <span [class.text-preferred-label-color-red]="true"
                          [class.text-preferred-label]="true"
                    >{{ sc.preferredLabel }}</span>
                    <ng-container *ngIf="sc.redo">
                      <dp-badge [color]="'red'" [text]="'REDO'" class="ml-1"></dp-badge>
                    </ng-container>
                  </div>
                  <div class="text-service-center">
                    <span class="font-weight-bold">{{ sc.name }}</span>
                    <span *ngIf="[companies.SeaIm].includes(company)" class="pl-8px font-size-11">
                  {{
                        sc.address?.address1.concat(', ')
                          .concat(sc.address?.city).concat(', ')
                          .concat(sc.address?.state).concat(', ')
                          .concat(sc.address?.zipcode)
                      }}</span>
                  </div>
                </td>

                <!-- Center Type & Star -->
                <td class="align-middle text-center">
                  <div role="button">
                    <div class="text-service-center">{{ sc.centerType }}</div>
                    <div *ngIf="sc.star" class="text-nowrap" style="font-size: 0.6rem;">
                      <app-star-rating [forDisplay]="true" [score]="sc.star"></app-star-rating>
                    </div>
                  </div>
                </td>

                <!-- Slot name & Pick Button -->
                <td class="text-center">
                  <!-- schedules null is pick -->
                  <ng-container *ngIf="sc.schedules | capacity; else isPick">
                    <ng-container *ngFor="let schedule of sc.schedules; first as isFirst">
                      <ng-container *ngIf="isFirst">
                        <div *ngFor="let key of schedule.capacity | keys" class="text-service-key">
                          {{ key | uppercase }}
                        </div>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                  <ng-template #isPick>
                    <button (click)="onSelectedPick(sc, null)"
                            [ngClass]="{'active-schedule': sc.ascNo === this.serviceCenter?.ascNo && !this.serviceCenter?.schedule}"
                            class="btn btn-sm btn-outline-schedule pt-0 pb-0" role="button">
                      <i class="fal fa-check"></i>
                    </button>
                  </ng-template>
                </td>
                <td>
                </td>
                <td class="text-preferred-label-color-red text-preferred-label-description" colspan="7">
                  This ASC will reach out to setup specific appointment date
                </td>
              </tr>
            </ng-container>
            </tbody>
          </ng-container>
          <ng-template #secaAndMxDatePick>
            <tbody>
            <tr *ngFor="let sc of serviceCenters; index as i;" [attr.data-asc-no]="sc.ascNo">
              <td class="align-middle">
                <div class="mb-8px">
                  <span class="text-asc-no">{{ sc.ascNo }}</span>
                  <span [class.text-preferred-label-color-blue]="sc.preferredLabel === 'Preferred'"
                        [class.text-preferred-label-color-red]="sc.preferredLabel === 'Other'"
                        [class.text-preferred-label]="true"
                  >{{ sc.preferredLabel }}</span>
                  <ng-container *ngIf="sc.redo">
                    <dp-badge [color]="'red'" [text]="'REDO'" class="ml-1"></dp-badge>
                  </ng-container>
                </div>
                <div class="text-service-center">
                  <span class="font-weight-bold">{{ sc.name }}</span>
                  <span *ngIf="[companies.SeaIm].includes(company)" class="pl-8px font-size-11">
                  {{
                      sc.address?.address1.concat(', ')
                        .concat(sc.address?.city).concat(', ')
                        .concat(sc.address?.state).concat(', ')
                        .concat(sc.address?.zipcode)
                    }}</span>
                </div>
              </td>

              <!-- Center Type & Star -->
              <td class="align-middle text-center">
                <div role="button">
                  <div class="text-service-center">{{ sc.centerType }}</div>
                  <div *ngIf="sc.star" class="text-nowrap" style="font-size: 0.6rem;">
                    <app-star-rating [forDisplay]="true" [score]="sc.star"></app-star-rating>
                  </div>
                </div>
              </td>

              <!-- Slot name & Pick Button -->
              <td class="text-center">
                <!-- schedules null is pick -->
                <ng-container *ngIf="sc.schedules | capacity; else isPick">
                  <ng-container *ngFor="let schedule of sc.schedules; first as isFirst">
                    <ng-container *ngIf="isFirst">
                      <div *ngFor="let key of schedule.capacity | keys" class="text-service-key">
                        {{ key | uppercase }}
                      </div>
                    </ng-container>
                  </ng-container>
                </ng-container>
                <ng-template #isPick>
                  <button (click)="onSelectedPick(sc, null)"
                          [ngClass]="{'active-schedule': sc.ascNo === this.serviceCenter?.ascNo && !this.serviceCenter?.schedule}"
                          class="btn btn-sm btn-outline-schedule pt-0 pb-0" role="button">
                    <i class="fal fa-check"></i>
                  </button>
                </ng-template>
              </td>

              <!-- Daily Slot Buttons -->
              <ng-container *ngIf="[companies.Sea].includes(company)">
                <td *ngFor="let schedule of serviceCentersSchedule[i]" class="text-center">
                  <ng-container *ngIf="sc.schedules | capacity; else isSelectedPick">
                    <ng-container *ngFor="let key of schedule.capacity | keys">
                      <ng-container *ngIf="schedule.capacity[key]; else capacity">
                        <button (click)="onSelected(sc, schedule, key)"
                                [disabled]="schedule.capacity[key] < 0"
                                class="btn btn-sm btn-outline-schedule pt-0 pb-0">
                          <ng-container *ngIf="schedule.capacity[key] < 0; else capacityTmp">
                            <i class="fal fa-check"></i>
                          </ng-container>
                          <ng-template #capacityTmp>
                            <div [ngClass]="{'active-schedule': schedule.date === this.serviceCenter?.schedule?.date &&
                                          schedule.capacity[key] === this.serviceCenter?.schedule?.capacity[this.serviceCenter?.schedule?.key]}"
                                 class="default-slot">
                              {{ schedule.capacity[key] }}
                            </div>
                          </ng-template>
                        </button>
                        <br/>
                      </ng-container>
                      <ng-template #capacity>
                        <div class="default-slot">&nbsp;</div>
                      </ng-template>
                    </ng-container>
                  </ng-container>
                  <ng-template #isSelectedPick>
                    <button (click)="onSelectedPick(sc, schedule)"
                            *ngIf="!schedule.blocked"
                            [ngClass]="{'active-schedule': schedule === this.serviceCenter?.schedule}"
                            class="btn btn-sm btn-outline-schedule pt-0 pb-0">
                      <i class="fal fa-check"></i>
                    </button>
                  </ng-template>
                </td>
              </ng-container>
            </tr>
            </tbody>
          </ng-template>


        </table>
      </div>
      <div *ngIf="[companies.Sea].includes(company) && userAgreement"
           class="text-preferred-label-color-red text-preferred-label-description">* Other: Appointment displayed is
        requested date only and subject to change
      </div>
    </ng-container>
    <ng-template #NoServiceCenterTemp>
      <div class="item-row mb-8px">
        <div class="item-label">Pick</div>
        <div class="item-value">
          <button (click)="onNoServiceCenterSelectPick()"
                  [ngClass]="{'active-schedule': [constants.specialAsc.ASC_FOR_LENNAR.ascNo, constants.specialAsc.NO_ASC.ascNo, constants.specialAsc.NO_ASC_FOR_SI.ascNo].includes(this.serviceCenter?.ascNo)}"
                  class="btn btn-sm btn-outline-schedule pt-0 pb-0" role="button">
            <i class="fal fa-check"></i>
          </button>
          <span class="pl-4x">{{ SPECIAL_ASC_LENNAR }}</span>
        </div>
      </div>
    </ng-template>
  </ng-template>

  <div class="ticket-horizontal-line"></div>
</div>
